import { render } from "./NoProductsCard.vue?vue&type=template&id=42b6fa1b"
import script from "./NoProductsCard.vue?vue&type=script&lang=js"
export * from "./NoProductsCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/Microfrontends/devices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__